<div class="footer">
  <div class="footerInner">
    <p class="mb-0">
      <a href="{{ companyUrl }}" title="{{ companyName | uppercase }}" target="_blank" rel="noopener noreferrer" class="logo">
        {{ applicationName }}
        <span></span>
      </a>
      Copyright © {{ year }} {{ companyName | uppercase }}
    </p>
  </div>
</div>
